<template>
  <div v-if="isTextAction" class="ri-large-body action-icon"
       @click.stop="onClick" @keyup.enter="onClick" role="button" tabindex="0">
    {{actionText}}
  </div>
  <icon v-else class="action-icon" :class="{ disabled }"
        @click.stop="onClick" @keyup.enter="onClick" role="button" tabindex="0"
        v-bind="iconProps"/>
</template>

<script>
import Colors from '../../scss/riseup-js-colors.module.scss';
import Icon from '../Icon.vue';
import { ACTION_TO_ACTION_TEXT, ACTION_TO_ICON_NAME, ACTIONS } from './ActionIcon.consts';

export default {
  name: 'ActionIcon',
  components: { Icon },
  props: {
    actionType: {
      type: String,
      require: true,
      validator: val => ACTIONS.includes(val),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    overrideIconProps: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      darkTextColor: Colors.riseupBlack,
      lightTextColor: Colors.riseupWhite,
    };
  },
  computed: {
    actionText() {
      return ACTION_TO_ACTION_TEXT[this.actionType];
    },
    iconName() {
      return ACTION_TO_ICON_NAME[this.actionType];
    },
    isTextAction() {
      return !!this.actionText;
    },
    iconProps() {
      return {
        color: this.textColor,
        size: '24px',
        weight: '700',
        fill: true,
        ...this.overrideIconProps,
        iconName: this.iconName, // don't allow overriding the icon name, use the ACTIONS map instead
      };
    },
  },
  methods: {
    onClick() {
      if (!this.disabled) {
        this.$emit('click');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/riseup-colors";

.action-icon {
  cursor: pointer;
  &.disabled {
    cursor: default;
    opacity: 0.6;
  }
}
</style>
